/* ============================================================
   Post-lead qualification quiz (сторінка подяки).

   Відновлено оригінальну логіку з вихідного архіву:
     · лід уже створено на лендінгу (main.js), сюди приходить
       lead_ref із sessionStorage — quiz.js його НЕ створює,
       лише доповнює;
     · 4 питання, кожна відповідь надсилається ОДРАЗУ, окремим
       запитом на C.endpoint (JSON, POST). Якщо C.endpoint
       порожній — заглушка: console.info + localStorage
       (ключ '<prefix>_qualify'), щоб перевірити фронт без
       реального бекенду;
     · Qualification status: Not started → In progress → Completed,
       рахується локально й додається в кожен payload.

   QUIZ_CONFIG — з wp_localize_script() (advokat_get_quiz_config()):
     {
       prefix:   'ap',
       partner:  'advokat-google-search',
       endpoint: '',                 // '' → заглушка (console + localStorage)
       leadId:   '',                 // серверний id ліда, якщо є (?lid=)
       questions: [{ field, q, options: [{ code, label }] }],
       i18n: { progress, doneTitle, doneText }
     }
   ============================================================ */
(function () {
  'use strict';

  var C = window.QUIZ_CONFIG;
  var root = document.getElementById('quiz');
  if (!C || !root || !C.questions || !C.questions.length) return;

  var PREFIX = C.prefix || 'ap';
  var REF_KEY = PREFIX + '_lead_ref';
  var STORE_KEY = PREFIX + '_quiz';
  var STATUS = { none: 'Not started', progress: 'In progress', done: 'Completed' };

  function ss(get, key, val) {
    try {
      if (get) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  var leadRef = ss(true, REF_KEY) || '';
  var leadId = C.leadId || '';

  var saved = {};
  try { saved = JSON.parse(ss(true, STORE_KEY) || '{}'); } catch (e) { saved = {}; }
  if (!saved.answers) saved.answers = {};
  /* Новий лід (новий lead_ref) — новий квіз: без цього повторний
     заїзд того самого відвідувача показав би старий "done" стан
     і чіпляв відповіді до вже неактуального ліда. */
  if (saved.ref !== leadRef) saved = { ref: leadRef, answers: {} };

  function persist() { ss(false, STORE_KEY, JSON.stringify(saved)); }

  function status() {
    var n = Object.keys(saved.answers).length;
    if (n === 0) return STATUS.none;
    return n >= C.questions.length ? STATUS.done : STATUS.progress;
  }

  /* -------- транспорт: кожна відповідь іде окремо й одразу -------- */
  function send(field, code, label) {
    var payload = {
      type: 'lead_qualification',
      partner: C.partner || '',
      lead_ref: leadRef,
      lead_id: leadId,
      field: field,
      value: label,          /* людська відповідь */
      value_code: code,      /* стабільний код для аналітики */
      qualification_status: status(),
      page: location.href,
      ts: new Date().toISOString()
    };

    if (C.endpoint) {
      try {
        fetch(C.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true /* 4-та відповідь часто передує закриттю вкладки */
        }).catch(function () {});
      } catch (e) {}
    } else {
      // заглушка до підключення реального ендпоінту
      console.info('[qualify] (заглушка, endpoint не задано)', payload);
      try {
        var arr = JSON.parse(localStorage.getItem(PREFIX + '_qualify') || '[]');
        arr.push(payload);
        localStorage.setItem(PREFIX + '_qualify', JSON.stringify(arr.slice(-100)));
      } catch (e) {}
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'lead_qualification',
        q_field: field, q_value: code, q_status: payload.qualification_status
      });
    }
  }

  /* ------------------------------ UI ------------------------------ */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function nextIndex() {
    for (var i = 0; i < C.questions.length; i++) {
      if (!(C.questions[i].field in saved.answers)) return i;
    }
    return -1;
  }

  function render() {
    root.innerHTML = '';
    var i = nextIndex();
    if (i === -1) { renderDone(); return; }
    var q = C.questions[i];

    var card = el('div', 'quiz-card');
    card.appendChild(el('p', 'quiz-progress',
      (C.i18n.progress || 'Питання %1 з %2').replace('%1', i + 1).replace('%2', C.questions.length)));
    card.appendChild(el('h3', 'quiz-q', q.q));

    var list = el('div', 'quiz-opts');
    q.options.forEach(function (o) {
      var b = el('button', 'quiz-opt', o.label);
      b.type = 'button';
      b.addEventListener('click', function () {
        if (b.classList.contains('is-sent')) return;
        b.classList.add('is-sent');
        saved.answers[q.field] = { code: o.code, label: o.label };
        persist();
        send(q.field, o.code, o.label);
        setTimeout(render, 180);   /* коротка пауза, щоб клік було видно */
      });
      list.appendChild(b);
    });
    card.appendChild(list);
    root.appendChild(card);
  }

  function renderDone() {
    if (!saved.done) {
      saved.done = true;
      persist();
      if (window.dataLayer) window.dataLayer.push({ event: 'lead_qualification_completed' });
    }
    var card = el('div', 'quiz-card quiz-card--done');
    var badge = el('div', 'quiz-done-badge');
    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.4 4.4L19.5 6.5"/></svg>';
    card.appendChild(badge);
    card.appendChild(el('h3', 'quiz-q', C.i18n.doneTitle || 'Дякуємо!'));
    card.appendChild(el('p', 'quiz-done-text', C.i18n.doneText || ''));
    root.innerHTML = '';
    root.appendChild(card);
  }

  render();
})();